import React, { Suspense, lazy } from "react";
import ErrorBoundary from "../../../Molecules/Common/error/ErrorBoundary.jsx";
import LoaderSkeleton from "../../../Molecules/Common/LoaderSkeleton.jsx";
import { contentTypes, externalTypes } from "./layout.Helper.js";
const M_ChartCard = lazy(() =>
  import("../../../Molecules/Common/Renderers/Views/Charts/M_ChartCard.jsx")
);
const M_MapCard = lazy(() =>
  import("../../../Molecules/Common/Renderers/Views/MapCards/M_MapCard.jsx")
);
const ViewFields = lazy(() => import("../Fields/ViewFields.jsx"));
const DisplaySections = lazy(() =>
  import("../DisplaySection/DisplaySection.jsx")
);
const DisplayTabs = lazy(() => import("../DisplayTabs/DisplayTabs.jsx"));
const M_ResultCard = lazy(() =>
  import(
    "../../../Molecules/Common/Renderers/Views/ResultCards/M_ResultCard.jsx"
  )
);
const M_DropableFileUpload = lazy(() =>
  import("../../../Molecules/Common/File Upload/M_DropableFileUpload.jsx")
);
const PreviousTemplate = lazy(() =>
  import(
    "../../../Molecules/Common/Renderers/Views/PreviousTemplate/PreviousTemplate.jsx"
  )
);
const PreviousUploads = lazy(() =>
  import(
    "../../../Molecules/Common/Renderers/Views/PreviousTemplate/PreviousUploads.jsx"
  )
);
const O_DealTimeline = lazy(() =>
  import("../../../Organisms/Common/DealTimeline/O_DealTimeline.jsx")
);
const O_Historychart = lazy(() =>
  import("../../../Organisms/Common/Historychart/O_Historychart.jsx")
);
const O_IRCDetails = lazy(() =>
  import("../../../Organisms/Common/IRCDetails/O_IRCDetails.jsx")
);
const O_MeetingSlotCard = lazy(() =>
  import("../../../Organisms/Common/MeetingSlotCard/O_MeetingSlotCard.jsx")
);
const Guidelines = lazy(() =>
  import("../../../Organisms/Common/Guidelines/Guidelines.jsx")
);
const ChecklistMaster = lazy(() => import("../Checklist/ChecklistMaster.jsx"));
const DealTeam = lazy(() => import("../DealTeam/DealTeam.jsx"));
const O_CheckList = lazy(() =>
  import("../../../Organisms/Common/Checklist/O_Checklist.jsx")
);
const MapGoogle = lazy(() => import("../../../Atoms/Map/A_GoogleMap.jsx"));
const Image = lazy(() => import("../../../Atoms/Image/A_Image.jsx"));
const ManageInvoices = lazy(() =>
  import("../../../Molecules/Common/PDFReader/ManageInvoices.jsx")
);
const M_ListDetails = lazy(() =>
  import("../../../Molecules/Common/DealAdministartion/M_ListDetails.jsx")
);
const PortfolioApproval = lazy(() =>
  import("../PortfolioManagement/PortfolioApproval.jsx")
);
const M_PortfolioFileUpload = lazy(() =>
  import("../../../Molecules/Common/File Upload/M_PortfolioFileUpload.jsx")
);
const ImageGallery = lazy(() =>
  import("../../../Organisms/Common/ImageGallery/ImageGallery.jsx")
);
const Annoucment = lazy(() =>
  import("../../../Molecules/Announcment/Annoucement.jsx")
);
const GenericList = lazy(() =>
  import("../../../Organisms/Common/GenericList/GenericList.jsx")
);
const QuickLinks = lazy(() =>
  import("../../../Molecules/QuickLink/QuickLinks.jsx")
);
const ImageCard = lazy(() =>
  import("../../../Molecules/ImageCard/ImageCard.jsx")
);
const O_NewsPortal = lazy(() =>
  import("../../../Organisms/Common/NewsPortal/O_NewsPortal.jsx")
);
const M_PDFReader = lazy(() =>
  import("../../../Molecules/Common/PDFReader/M_PDFReader.jsx")
);
const ManualUpdate = lazy(() =>
  import(
    "../../../Molecules/Common/Renderers/Views/ManualUpdate/ManualUpdate.jsx"
  )
);
const IRReport = lazy(() =>
  import("../../../Organisms/Common/IRReport/IRReport.jsx")
);
const A_Tearsheet = lazy(() =>
  import("../../../Atoms/DataDisplay/Tearsheet/A_Tearsheet.jsx")
);
const M_CustomView = lazy(() => import("./CustomCards/M_CustomView.jsx"));
const Comment = lazy(() =>
  import("../../../Atoms/Inputs/DropdownFields/Comment.jsx")
);
const M_MediaUpload = lazy(() =>
  import("../../../Organisms/Common/Summarix/M_MediaUpload.jsx")
);

export default function showContentConditional(
  contentType,
  content,
  item,
  chartFilter,
  parentThis
) {
  const { syncEdgeLabel } = item.header;
  switch (contentType) {
    case contentTypes.CRMDATA:
      if (content && content.tabs) {
        return (
          <ErrorBoundary>
            <Suspense fallback={<LoaderSkeleton />}>
              <DisplayTabs
                tabs={content.tabs}
                chartFilter={chartFilter}
                data={parentThis.props.data}
                CurrentCard={item}
              />
            </Suspense>
          </ErrorBoundary>
        );
      } else if (content && content.sections) {
        return (
          <ErrorBoundary>
            <Suspense fallback={<LoaderSkeleton />}>
              <DisplaySections sections={content.sections} />
            </Suspense>
          </ErrorBoundary>
        );
      } else if (content && content.fields) {
        return (
          <ErrorBoundary>
            <Suspense fallback={<LoaderSkeleton />}>
              <ViewFields
                fields={content.fields}
                syncEdgeLabel={syncEdgeLabel}
                content={content}
                CurrentCard={item}
                {...parentThis.props}
              />
            </Suspense>
          </ErrorBoundary>
        );
      }
      break;
    case contentTypes.SQLVIEW:
      return <ErrorBoundary>
        <Suspense fallback={<LoaderSkeleton />}>
          <M_CustomView
            data={parentThis.props.data}
            CurrentCard={item}
          />
        </Suspense>
      </ErrorBoundary>
    case contentTypes.CHART:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <M_ChartCard
              key={`${content?.chart?.id || ''}-${parentThis?.props?.params?.crmId || ''}`}
              Height={!item.minHeight ? "300px" : `${item.minHeight}px`}
              {...parentThis.props}
              chartFilter={chartFilter}
              content={
                content && content.chart
                  ? {
                    ...content.chart,
                    chartId: content.chart.id,
                    id: undefined,
                  }
                  : {}
              }
              chartInfoRef={content?.chartInfoRef}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.MAPS:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <M_MapCard content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.MANUAL_UPDATE:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <ManualUpdate content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.IR_REPORT:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <IRReport content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.RESULT_TEMPLATE:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <M_ResultCard
              content={content}
              stateObj={parentThis.state}
              item={item}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.DOCUMENTS:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <M_DropableFileUpload
              content={content}
              currentPage={parentThis.props.currentPage}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.PORTFOLIO_FILE_UPLOAD:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <M_PortfolioFileUpload
              content={content}
              currentPage={parentThis.props.currentPage}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.PREVIOUS_TEMPLATE:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <PreviousTemplate content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.PREVIOUS_UPLOADS:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <PreviousUploads content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.TIMELINE:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <O_DealTimeline content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.GUIDELINES:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <Guidelines content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.MAPGOOGLE:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <MapGoogle content={content} data={parentThis.props.data} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.IRC_DETAIL:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <O_Historychart
              maxHeight={content.maxHeight}
              content={content}
              callBack={parentThis.handleRecordID}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.DEAL_ADMINISTRATION:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <O_IRCDetails
              content={content}
              callBack={parentThis.handleRecordID}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.BOOKING_SLOT:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <O_MeetingSlotCard
              maxHeight={content.maxHeight}
              content={content}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.IC_VIEW:
      return (
        <Suspense fallback={<LoaderSkeleton />}>
          <M_ListDetails
            type={externalTypes.IRC}
            id={parentThis.state.recordId}
            resPayload={content && content.resPayload ? content.resPayload : ""}
            config={content && content.ircTabs ? content.ircTabs : []}
            content={content}
          />
        </Suspense>
      );
    case contentTypes.GENERIC_RESULT_TEMPLATE:
      return (
        <Suspense fallback={<LoaderSkeleton />}>
          <GenericList content={content}></GenericList>
        </Suspense>
      );
    case contentTypes.CHECKLIST_MASTER:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <ChecklistMaster
              content={content}
              data={
                parentThis.props.data && parentThis.props.data.checklistResponse
                  ? parentThis.props.data.checklistResponse
                  : null
              }
              percentComplete={
                parentThis.props.data &&
                  parentThis.props.data.checklistStatistics
                  ? parentThis.props.data.checklistStatistics
                  : null
              }
              dealData={parentThis.props.data ? parentThis.props.data : null}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.MANAGED_BY:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <DealTeam
              content={content}
              currentPage={parentThis.props.currentPage}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.CHECKLIST:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <O_CheckList ircID={parentThis.state.recordId} config={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.MANAGE_INVOICES:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <ManageInvoices content={content} data={parentThis.props.data} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.IMAGE:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <Image content={content} {...parentThis.props}></Image>
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.TEARSHEET:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <A_Tearsheet></A_Tearsheet>
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.PORTFOLIOAPPROVAL:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <PortfolioApproval
              content={content}
              getCurrentPage={parentThis.props.getCurrentPage}
              approvalData={parentThis.state.approversubmission}
            />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.IMAGE_GALLERY:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <ImageGallery content={content} {...parentThis.props} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.ANNOUCMENT:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <Annoucment content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.QUICK_LINKS:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <QuickLinks content={content} {...parentThis.props} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.IMAGE_CARD:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <ImageCard content={content} {...parentThis.props} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.NEWS_PORTAL:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <O_NewsPortal content={content} {...parentThis.props} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.STATIC_PDF:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <M_PDFReader
              pdf={content.filename ? content.filename : ""}
              showDefaultMessage={true}
              container={content.type ? content.type : externalTypes.GENERIC}
            />
          </Suspense>
        </ErrorBoundary>
      );
  case contentTypes.COMMENT:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <Comment content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    case contentTypes.SUMMARIX:
      return (
        <ErrorBoundary>
          <Suspense fallback={<LoaderSkeleton />}>
            <M_MediaUpload content={content} />
          </Suspense>
        </ErrorBoundary>
      );
    default:
      return "";
  }
}
